import React from "react";
import { observer } from "mobx-react-lite";

import FormField from "../form-field/FormField";
import { dateService } from "../../services/date-service/DateService";

interface DateAdded {
  date?: Date | string;
}

export default observer(function DisplayDateAdded(props: DateAdded) {
  return (
    <FormField
      id="date-added"
      labelKey="general.date-added"
      readOnly
      fieldValue={props.date ? dateService.formatDate(props.date) : "-"}
    />
  );
});
